import FouContainer from 'components/tools/fou-container/'
import FouModal from 'components/overlay/fou-modal/'
import FouGrid from 'components/layout/fou-grid/'
import FouGroup from 'components/layout/fou-group/'
import MyfontsShortCircleIcon from 'components/icons/myfonts-short-circle/'
import FouPicture from 'components/tools/fou-picture/'
import Methods from './externalsku.methods'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import SubmissionMethods from 'src/pages/submissions/script/common.methods'
import { mapGetters } from 'vuex'
import Misc from 'src/utils/helper/misc'
import { useForm } from 'vee-validate'
import TextField from 'src/components/form/text-field/index.vue'
import { errors as submissionErrors } from 'src/pages/submissions/script/common.data'
import { isEmpty } from 'lodash'

export default {
  name: 'externalsku',

  data() {
    return {
      externalsku: '',
      singleStyleData: [],
      familyPackData: [],
      isSingleSkuAvailable: [],
      isSkuAvailable: false
    }
  },

  setup() {
    const { errors } = useForm()
    return {
      errors
    }
  },

  props: {
    familyPackSku: {
      type: Boolean,
      default: false
    },
    singlePackSku: {
      type: Boolean,
      default: false
    },
    customPackSku: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: null
    },
    elementId: {
      type: String,
      default: ''
    },
    result: {
      type: Object,
      default: () => ({})
    },
    mouseOverHandler: {
      type: Function,
      default: () => {}
    },
    mouseOutHandler: {
      type: Function,
      default: () => {}
    },
    tag: {
      type: String,
      default: 'upload'
    }
  },

  components: {
    FouContainer,
    FouModal,
    MyfontsShortCircleIcon,
    FouPicture,
    ...FouGrid,
    FouGroup,
    TextField
  },

  /**
   * Check if the error exists in the submission errors from common.data.js.
   * If error exists in the form, push to the global errors
   *  else manually remove the associated error from global errors
   */
  watch: {
    errors: {
      handler(newVal) {
        if (!isEmpty(newVal)) {
          submissionErrors.value.push(newVal)
          submissionErrors.value = [...new Set(submissionErrors.value.map(itm => JSON.stringify(itm)))].map(i =>
            JSON.parse(i)
          )
        } else {
          if (!isEmpty(this.elementId)) {
            submissionErrors.value = submissionErrors.value.filter(
              error => !Object.hasOwn(error, `external sku ${this.elementId} ${this.tag}`)
            )
          } else {
            submissionErrors.value = submissionErrors.value.filter(error => !Object.hasOwn(error, `external sku ${this.tag}`))
          }
        }
      },
      immediate: true
    }
  },

  computed: {
    ...SubmissionComputed,
    ...mapGetters('auth', ['hasRole', 'user']),
    getExternalSkuIndex() {
      return this.singleStyleData.findIndex(style => style.styles[0].binaryId === this.elementId)
    }
  },

  methods: {
    ...SubmissionMethods,
    ...Methods,
    ...Misc,
    updateSubmissionOnExternalSkuBlur() {
      if (isEmpty(this.errors)) {
        this.updateSubmission()
      }
    }
  },

  created() {
    this.setData()
    this.$events?.$on('update:external_sku', () => {
      this.$nextTick(() => {
        this.setData()
      })
    })
    this.$events?.$on('delete:single_package_sku', key => {
      this.removeSingleStyleSku(key)
    })
  },

  beforeUnmount() {
    this.$events.$off('update:external_sku', this.setData)
  }
}
